site.multiselect = {
	init: function(selector) {
		setTimeout(function() {
			$.localise('ui-multiselect', {language: moya.lang, path: '/_moya/js/jquery/multiselect/js/locale/'});
			$(selector).multiselect({
				sortable: true,
				searchable: true
			});
		}, 500);
	}
};
